// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"922bdaf4","250":"2a1dbf09","407":"e68cffef","436":"eb8a093a","453":"f394a27d","455":"2b9dbaca","501":"36aaf0e1","595":"4875401a","606":"b30ab923","691":"28b4b20e","821":"a44e1430","880":"c6b49cfa","925":"e75911aa","969":"f6c15a78"}[chunkId] + ".chunk.js";
};